import { useEffect, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { getCondicionIvaReceptor, getPuntosVenta, getTipoComprobantes, getTipoConceptos, getTipoDocumentos } from '../../../Services/apiAfipService'
import { createTicket } from '../../../Services/apiReports'
import { saveError } from '../../../Services/errorService'
import { saveVentas } from '../../../Services/ventaService'
import { calculoIvas, determinarPrecio, generateQRUrl, getConcepto } from '../FacturaElectronicaModal/utils'

const useFacturaElectronicaModal = (getVentaFE,
  handleShowFE,
  handleCloseFE,
  handleClose,
  reset,
  isLoad,) => {

  const [venta, setVenta] = useState({})

  const [tipoDocumentos, setTipoDocumentos] = useState([])
  const [tipoDocumento, setTipoDocumento] = useState(96)

  const [puntoVentas, setPuntoVentas] = useState([])
  const [puntoVentaAfip, setPuntoVentaAfip] = useState()

  const [tipoComprobantes, setTipoComprobantes] = useState([])
  const [tipoComprobante, setTipoComprobante] = useState(11)

  const [tipoConceptos, setTipoConceptos] = useState([])
  const [tipoConcepto, setTipoConcepto] = useState(1)

  const [condicionesIvasReceptores, setCondicionesIvasReceptores] = useState([])
  const [condicionIvaReceptor, setCondicionIvaReceptor] = useState(5)

  const [nroDocumento, setNroDocumento] = useState(1)

  const [apiKey, setApiKey] = useState(1)
  const [isModalReady, setIsModalReady] = useState(false)
  const isDisabledButton = useMemo(() => {
    if (!apiKey) return true;
    if (!getVentaFE || typeof getVentaFE !== 'function') return true;

    try {
      const ventaData = getVentaFE();
      // Si no hay datos válidos, deshabilitar el botón
      if (!ventaData) return true;

      // Verificar si hay medios de pago
      if (!ventaData.medioPagos || ventaData.medioPagos.length === 0) return true;

      // Verificar que el saldo total sea igual a la suma de los montos
      if (ventaData.medioPagos && ventaData.medioPagos.length > 0) {
        const total = parseFloat(ventaData.venta.total);
        const sumaMedioPagos = ventaData.medioPagos.reduce(
          (suma, medioPago) => suma + parseFloat(medioPago.monto), 0
        );

        if (Math.abs(total - sumaMedioPagos) > 0.01) return true;
      }

      return false;
    } catch (error) {
      console.error('Error al validar datos para la factura electrónica:', error);
      return true;
    }
  }, [apiKey, getVentaFE]);



  useEffect(() => {
    if (isModalReady && isLoad) {
      const pt = JSON.parse(sessionStorage.getItem('ptoventa'))

      setApiKey(pt.datoFiscal.apiKey || null)

      getTipoDocumentos().then((data) => {
        setTipoDocumentos(data.data.ResultGet.DocTipo)
      })
      getPuntosVenta()
        .then((data) => {
          setPuntoVentas(data.data.ResultGet.PtoVenta)
          setPuntoVentaAfip(pt.datoFiscal.puntoVenta)
        })
        .catch((err) => {
          console.log(err)
          setPuntoVentaAfip(1) // solo para dev
        })
      getTipoComprobantes().then((data) => {
        setTipoComprobantes(data.data.ResultGet.CbteTipo)
      })
      getTipoConceptos().then((data) => {
        setTipoConceptos(data.data.ResultGet.ConceptoTipo)
      })
      getCondicionIvaReceptor().then((data) => {
        setCondicionesIvasReceptores(data.data.ResultGet.CondicionIvaReceptor)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalReady, isLoad])

  const handleShowFirst = () => {
    const ventaData = getVentaFE();
    setVenta(ventaData);

    // Obtener datos del cliente
    const cliente = ventaData.venta.cliente;

    // Determinar si el cliente es Responsable Inscripto verificando la condición fiscal
    const esResponsableInscripto = cliente.condicionFiscal?.id === 1;

    if (esResponsableInscripto && ventaData.venta.tipoComprobante.id === 1) {
      // Cliente es Responsable Inscripto
      setTipoComprobante(1); // Tipo A
      setTipoDocumento(80); // CUIT
      setNroDocumento(cliente.id.persona.cuilCuit || cliente.id.persona.dni);
      setCondicionIvaReceptor(1); // Responsable Inscripto
    } else {
      // Cliente es Consumidor Final, Monotributista u otro tipo
      setTipoComprobante(11); // Tipo C
      setTipoDocumento(96); // DNI
      setNroDocumento(cliente.id.persona.dni);
      setCondicionIvaReceptor(5); // Consumidor Final
    }

    setIsModalReady(true);
    handleShowFE();
  }

  const finalizarVentaFE = async () => {
    const detalleIva = calculoIvas(venta.venta.items)

    const dataVentaRequest = {
      ...venta,
      apiAfipRequest: {
        puntoVenta: Number(puntoVentaAfip),
        tipoComprobante: Number(tipoComprobante),
        concepto: getConcepto(Number(tipoConcepto)),
        tipoDocumento: Number(tipoDocumento),
        documentoNumero: Number(nroDocumento),
        importeExentoIva: 0,
        importeTotalTributo: 0,
        condicionIVAReceptor: Number(condicionIvaReceptor),
        ...(tipoComprobante === 11
          ? {
            importeTotal: Number(venta.venta.total), //importe total c/impuestos
            importeNetoNoGravado: 0, //importe neto no agravado, para factura C debe ser igual a cero
            importeNeto: Number(venta.venta.total), //importe total neto (s/ impuestos) para factura c debe ser igual al importe total.
            importeExentoIva: 0, //importe exento, en factura c debe ser igual a cero
            importeTotalIva: 0, //suma de todos los ivas, en factura c debe ser cero
            importeTotalTributo: 0, //suma del arreglo de tributos
          }
          : {
            importeTotal: Math.round(
              detalleIva.impIva + detalleIva.impNeto,
              2
            ), //importe total c/impuestos
            importeNetoNoGravado: 0, //importe neto no agravado, para factura C debe ser igual a cero
            importeNeto: Math.round(detalleIva.impNeto, 2), //importe total neto (s/ impuestos) para factura c debe ser igual al importe total.
            importeExentoIva: 0, //importe exento, en factura c debe ser igual a cero
            importeTotalIva: Math.round(detalleIva.impIva, 2), //suma de todos los ivas, en factura c debe ser cero
            importeTotalTributo: 0, //suma del arreglo de tributos
            iva: detalleIva.ivas,
          }),
      },
    }

    try {
      await saveVentas(dataVentaRequest)
        .then(async (res) => {
          const ventaRes = res.data.venta
          const { cliente } = ventaRes
          const cobrosParcializados = venta.medioPagos
          const fecha = new Date(ventaRes.createdAt)
          Swal.fire({
            toast: true,
            position: 'top',
            type: 'success',
            showConfirmButton: false,
            title: 'Venta realizada.',
            timer: 2500,
          })
          handleCloseFE()
          handleClose()
          reset()
          const puntoVenta = JSON.parse(
            sessionStorage.getItem('ptoventa')
          )
          const ticket = await createTicket({
            nombreLocal:
              sessionStorage.getItem('tenant') || 'Magenta',
            propietario: {
              razonSocial:
                puntoVenta.datoFiscal.razonSocial || '',
              cuit: puntoVenta.datoFiscal.cuitCuil || '',
              domicilio:
                puntoVenta.datoFiscal.domicilioFiscal || '',
              condicionFiscal:
                puntoVenta.datoFiscal.condicionFiscal.nombre ||
                '',
            },
            cliente: {
              nombre: `${cliente.id.persona.nombre || ''} ${cliente.id.persona.apellido || ''}`,
              domicilio: cliente.id.persona.direccion || '',
              cuit:
                cliente.id.persona.cuilCuit ||
                cliente.id.persona.dni,
              condicionFiscal: cliente.id.nombre || '',
            },
            fecha: fecha.toLocaleDateString(),
            hora: fecha.toLocaleTimeString(),
            venta: {
              tipoComprobante:
                ventaRes.tipoComprobante.nombre || '',
              puntoVenta: puntoVentaAfip,
              numComprobante: ventaRes.facturada
                ? ventaRes.numeroComprobanteAfip
                : ventaRes.numeroComprobante,
              items: ventaRes.items.map((i) => {
                if (i.departamento) {
                  const tasaIva = i.departamento.tasaIva
                  const precio = determinarPrecio(
                    i.precio * i.cantidad,
                    tasaIva,
                    tipoComprobante
                  )
                  return {
                    nombre: i.departamento.nombre,
                    cantidad: `${i.cantidad} x ${i.precio}`,
                    monto: precio,
                  }
                } else {
                  const tasaIva =
                    i.articulo.familia.departamento.tasaIva
                  const precio = i.articulo.pesable
                    ? determinarPrecio(
                      i.precio,
                      tasaIva,
                      tipoComprobante
                    )
                    : determinarPrecio(
                      i.precio * i.cantidad,
                      tasaIva,
                      tipoComprobante
                    )
                  return {
                    nombre: i.articulo.nombre,
                    cantidad: i.articulo.pesable
                      ? `${i.cantidad} x ${i.articulo.precioFinal}`
                      : `${i.cantidad} x ${i.precio}`,
                    monto: precio,
                  }
                }
              }),
              medioPagos: cobrosParcializados.map((cp) => {
                return {
                  nombre: cp.medioPago.nombre,
                  monto: cp.monto,
                }
              }),
              cae: ventaRes.cae,
              caeVencimiento: `${ventaRes.caeFechaVencimiento.substring(0, 4)}/${ventaRes.caeFechaVencimiento.substring(4, 6)}/${ventaRes.caeFechaVencimiento.substring(6, 8)}`,
              facturada: ventaRes.facturada,
              ...(tipoComprobante === 11
                ? {
                  subtotal: ventaRes.total,
                  descuentoRecargo: 0,
                  iva0: 0,
                  iva105: 0,
                  iva21: 0,
                }
                : {
                  subtotal: Math.round(
                    ventaRes.total -
                    detalleIva.iva0 -
                    detalleIva.iva10 -
                    detalleIva.iva21,
                    2
                  ),
                  descuentoRecargo: 0,
                  iva0: detalleIva.iva0
                    ? Math.round(detalleIva.iva0, 2)
                    : 0,
                  iva105: detalleIva.iva10
                    ? Math.round(detalleIva.iva10, 2)
                    : 0,
                  iva21: detalleIva.iva21
                    ? Math.round(detalleIva.iva21, 2)
                    : 0,
                }),
              total: ventaRes.total,
              vuelto: 0,
              qr: generateQRUrl(
                ventaRes.caeVencimiento,
                puntoVenta.datoFiscal.cuitCuil,
                puntoVentaAfip,
                tipoComprobante,
                ventaRes.numeroComprobanteAfip,
                ventaRes.total,
                'PES',
                tipoDocumento,
                nroDocumento,
                ventaRes.cae
              ),
            },
            turno: 0,
          })
          const contenido = encodeURI(ticket.data)
          let excelWindow = window.open('')
          excelWindow.document.write(
            `<iframe width='100%' height='100%' margin='0px' padding='0px' src='data:application/pdf;base64, ${contenido}'>
            </iframe>`
          )
        })
        .catch(async (error) => {
          const errorData = {
            mensaje:
              'Error al finalizar la venta en factura electronica',
            detalle: error.message,
            entidad: 'VENTA',
            tipo: 'WEBAPP',
            severidad: 'HIGH',
            reportado: 'APPLICATION',
          }

          await saveError(errorData)
          Swal.fire({
            type: 'error',
            title: 'No se pudo proceder con la venta.',
            timer: 2500,
          })
        })
    } catch (error) {
      console.error(error.message)
    }
  }

  return {
    handleShowFirst,
    apiKey,
    isDisabledButton,
    tipoDocumento,
    setPuntoVentaAfip,
    puntoVentas,
    tipoComprobante,
    setTipoComprobante,
    tipoComprobantes,
    setTipoDocumento,
    tipoDocumentos,
    nroDocumento,
    setNroDocumento,
    tipoConcepto,
    setTipoConcepto,
    tipoConceptos,
    condicionIvaReceptor,
    setCondicionIvaReceptor,
    condicionesIvasReceptores,
    finalizarVentaFE
  }

}

export default useFacturaElectronicaModal